import { FormControl, Select, MenuItem, TextField } from '@mui/material';
import { useLanguage } from '../../../../contexts/language';
import { OperatorPartialFormProps } from '../types';
import { useAppDataContext } from '../../../../contexts/appData';
import FormLayout, {
  FormLayoutInputElement,
} from '../../../../components/FormLayout';

const OperatorAddressForm = ({ formManager }: OperatorPartialFormProps) => {
  const { t } = useLanguage();
  const {
    materialInputHelpers: {
      getBaseProps,
      getTextFieldProps,
      getSelectProps,
      renderError,
    },
  } = formManager;
  const {
    appData: { counties },
  } = useAppDataContext();

  return (
    <FormLayout>
      <FormLayoutInputElement required label={`${t('content.address-line')} 1`}>
        <TextField
          {...getTextFieldProps('addressLine1')}
          placeholder={`${t('content.address-line')} 1`}
        />
      </FormLayoutInputElement>
      <FormLayoutInputElement label={`${t('content.address-line')} 2`}>
        <TextField
          {...getTextFieldProps('addressLine2')}
          placeholder={`${t('content.address-line')} 2`}
        />
      </FormLayoutInputElement>
      <FormLayoutInputElement label={`${t('content.address-line')} 3`}>
        <TextField
          {...getTextFieldProps('addressLine3')}
          placeholder={`${t('content.address-line')} 3`}
        />
      </FormLayoutInputElement>
      <FormLayoutInputElement required label={t('content.county')}>
        <FormControl error={getBaseProps('county').error}>
          <Select {...getSelectProps('county')} id="counties-select">
            {Object.values(counties).map(county => (
              <MenuItem key={county} value={county}>
                {t(`counties.${county}`)}
              </MenuItem>
            ))}
          </Select>
          {renderError('county')}
        </FormControl>
      </FormLayoutInputElement>
      <FormLayoutInputElement required label="Eircode">
        <TextField {...getTextFieldProps('eirCode')} placeholder="Eircode" />
      </FormLayoutInputElement>
    </FormLayout>
  );
};

export default OperatorAddressForm;
